export default {
  payment: 'Payment',
  'payment.title': 'Provide your card details',
  'payment.description':
    'We accept Visa and Mastercard issued in UAE only. Please make sure your card validity is not less than your selected tenure.',
  'payment.cardNumber': 'Card number',
  'payment.expiryDate': 'MM/YY',
  'payment.cvvNumber': 'CVV',
  'payment.cardRequired': 'Please insert a card',
  'payment.expiryDateRequired': 'Please insert an expiry date',
  'payment.cvvRequired': 'Please insert a cvv code',
  'payment.security':
    'We use 3D security protocols to provide you greater security and protection against fraud.',
  'payment.cardHolder': 'Card holder',
};
